import flatpickr from 'flatpickr';
import { Russian } from 'flatpickr/dist/esm/l10n/ru';

flatpickr.localize(Russian);

// ─── Мобильный кастомный календарь (bottom-sheet) ─────────────────────────
var mobileCal = (function () {
    var container = null;
    var bodyEl    = null;
    var startDate = null;
    var endDate   = null;

    var MONTHS = ['Январь','Февраль','Март','Апрель','Май','Июнь',
                  'Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'];
    var DAYS   = ['Пн','Вт','Ср','Чт','Пт','Сб','Вс'];

    function fmt(d) {
        return d.getFullYear() + '-' +
            String(d.getMonth() + 1).padStart(2, '0') + '-' +
            String(d.getDate()).padStart(2, '0');
    }

    function toDate(str) {
        var p = str.split('-');
        return new Date(+p[0], +p[1] - 1, +p[2]);
    }

    function sameDay(a, b) {
        return a && b && fmt(a) === fmt(b);
    }

    function startOfDay(d) {
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    }

    function render() {
        if (!bodyEl) { return; }
        var today = startOfDay(new Date());
        var html  = '';

        for (var i = 0; i < 12; i++) {
            var absMonth = today.getMonth() + i;
            var yr  = today.getFullYear() + Math.floor(absMonth / 12);
            var mo  = absMonth % 12;

            var firstDay  = new Date(yr, mo, 1);
            var daysTotal = new Date(yr, mo + 1, 0).getDate();
            var firstDow  = (firstDay.getDay() + 6) % 7; // Пн = 0

            html += '<div class="mobile-cal__month">';
            html += '<div class="mobile-cal__month-name">' + MONTHS[mo] + ' ' + yr + '</div>';
            html += '<div class="mobile-cal__weekdays">';
            DAYS.forEach(function (n) {
                html += '<span class="mobile-cal__weekday">' + n + '</span>';
            });
            html += '</div><div class="mobile-cal__days">';

            for (var e = 0; e < firstDow; e++) {
                html += '<div class="mobile-cal__day mobile-cal__day--empty"></div>';
            }

            for (var day = 1; day <= daysTotal; day++) {
                var dt    = new Date(yr, mo, day);
                var dtStr = fmt(dt);

                var isPast       = dt < today;
                var isStart      = !isPast && sameDay(dt, startDate);
                var isEnd        = !isPast && sameDay(dt, endDate);
                var inRange      = !isPast && startDate && endDate &&
                                   dt > startDate && dt < endDate;
                var isRangeStart = isStart && endDate;
                var isRangeEnd   = isEnd   && startDate;

                var cls = 'mobile-cal__day';
                if (isPast)        { cls += ' is-past'; }
                if (isStart)       { cls += ' is-start'; }
                if (isEnd)         { cls += ' is-end'; }
                if (inRange)       { cls += ' is-in-range'; }
                if (isRangeStart)  { cls += ' is-range-start'; }
                if (isRangeEnd)    { cls += ' is-range-end'; }

                html += '<div class="' + cls + '"' +
                    (!isPast ? ' data-cal-date="' + dtStr + '"' : '') +
                    '><span>' + day + '</span></div>';
            }

            html += '</div></div>';
        }

        bodyEl.innerHTML = html;

        bodyEl.querySelectorAll('[data-cal-date]').forEach(function (el) {
            el.addEventListener('click', function (evt) {
                evt.stopPropagation();
                onDayClick(toDate(el.getAttribute('data-cal-date')));
            });
        });
    }

    function onDayClick(date) {
        date = startOfDay(date);
        if (!startDate || endDate || date < startDate) {
            startDate = date;
            endDate   = null;
        } else if (sameDay(date, startDate)) {
            startDate = null;
            endDate   = null;
        } else {
            endDate = date;
        }
        syncInput();
        render();
    }

    function syncInput() {
        var inp  = document.querySelector('#FlatSearchForm .date-range');
        var lbl  = document.querySelector('[data-ui-date-value]');
        var opts = { day: 'numeric', month: 'short' };

        if (!startDate) {
            if (inp) { inp.value = ''; }
            if (lbl) { lbl.textContent = 'Выберите'; lbl.classList.add('is-placeholder'); }
            return;
        }

        if (!endDate) {
            if (inp) { inp.value = fmt(startDate); }
            if (lbl) {
                lbl.textContent = startDate.toLocaleDateString('ru-RU', opts) + ' — ...';
                lbl.classList.remove('is-placeholder');
            }
            return;
        }

        if (inp) { inp.value = fmt(startDate) + ' — ' + fmt(endDate); }
        if (lbl) {
            lbl.textContent = startDate.toLocaleDateString('ru-RU', opts) + ' — ' +
                endDate.toLocaleDateString('ru-RU', opts);
            lbl.classList.remove('is-placeholder');
        }
    }

    function preload() {
        var inp = document.querySelector('#FlatSearchForm .date-range');
        if (!inp || !inp.value) { return; }
        var parts = inp.value.split(' — ');
        if (parts.length === 2) {
            startDate = startOfDay(toDate(parts[0].trim()));
            endDate   = startOfDay(toDate(parts[1].trim()));
        } else if (parts.length === 1 && parts[0].trim()) {
            startDate = startOfDay(toDate(parts[0].trim()));
        }
    }

    function open() {
        if (!container) { return; }
        preload();
        render();
        container.classList.add('is-open');
        document.body.classList.add('mobile-cal-open');
    }

    function close() {
        if (!container) { return; }
        container.classList.remove('is-open');
        document.body.classList.remove('mobile-cal-open');
    }

    function init() {
        container = document.getElementById('mobileCal');
        if (!container) { return; }
        bodyEl = document.getElementById('mobileCalBody');

        container.querySelector('.mobile-cal__backdrop')
            .addEventListener('click', close);
        container.querySelector('.mobile-cal__close')
            .addEventListener('click', close);

        var clearBtn = document.getElementById('mobileCalClear');
        if (clearBtn) {
            clearBtn.addEventListener('click', function () {
                startDate = null;
                endDate   = null;
                syncInput();
                render();
            });
        }

        var applyBtn = document.getElementById('mobileCalApply');
        if (applyBtn) {
            applyBtn.addEventListener('click', function () {
                syncInput();
                close();
                if (startDate && endDate) {
                    var form = document.getElementById('FlatSearchForm');
                    if (form) { form.submit(); }
                }
            });
        }
    }

    return { init: init, open: open, close: close };
})();
// ──────────────────────────────────────────────────────────────────────────

function getShowMonths() {
    return window.innerWidth <= 768 ? 1 : 2;
}

function initDatepicker() {
    if (window.innerWidth <= 768) {
        // На мобильных flatpickr не нужен — уничтожаем если остался,
        // заменяем фиктивным объектом чтобы universal-select.js открывал
        // мобильный календарь через openPicker()
        document.querySelectorAll('.date-range').forEach(function (input) {
            if (input._flatpickr && typeof input._flatpickr.destroy === 'function') {
                input._flatpickr.destroy();
            }
            input._flatpickr = {
                open:  function () { mobileCal.open(); },
                close: function () { mobileCal.close(); },
            };
        });
        return;
    }

    document.querySelectorAll('.date-range').forEach(function (input) {
        if (input._flatpickr && typeof input._flatpickr.destroy === 'function') {
            input._flatpickr.destroy();
        }
        flatpickr(input, {
            mode: 'range',
            dateFormat: 'Y-m-d',
            minDate: 'today',
            showMonths: getShowMonths(),
            enableDaysInPrevAndNextMonths: true,
            onChange: function (selectedDates) {
                if (selectedDates.length === 2) {
                    $('#FlatSearchForm').submit();
                }
            },
        });
    });
}

mobileCal.init();
initDatepicker();

// Прямой обработчик на кнопку-триггер поля дат (на мобильных открывает кастомный календарь)
document.addEventListener('DOMContentLoaded', function () {
    var dateTrigger = document.querySelector('[data-ui-date] .ui-select__trigger');
    if (dateTrigger) {
        dateTrigger.addEventListener('click', function (e) {
            if (window.innerWidth <= 768) {
                e.preventDefault();
                e.stopImmediatePropagation();
                mobileCal.open();
            }
        });
    }
});

window.addEventListener('resize', function () {
    document.querySelectorAll('.flatpickr-calendar').forEach(function (cal) {
        cal.remove();
    });
    initDatepicker();
});

